/*
 * fn: getUtmLink
 *
 * Gets a UTM link from an href and a list of utm parameters
 *
 */
import { SITE_URL, type UtmType } from '@/defs/misc'

import { parseError } from './parseError'

const HAS_ORIGIN = /^([a-z][\w+.-]*:)?\/\//i

export const getUtmLink = (href: string, params: UtmType = {}) => {
  if (!href || href.startsWith('#')) return href

  try {
    const url = new URL(href, SITE_URL)
    if (!/^https?:$/.test(url.protocol)) return href

    for (const [key, value] of Object.entries({ source: 'edhrec', ...params })) {
      const param = `utm_${key}`
      if (value && !url.searchParams.has(param)) url.searchParams.set(param, value)
    }

    return HAS_ORIGIN.test(href) ? url.href : `${url.pathname}${url.search}${url.hash}`
  } catch (e) {
    console.warn(`[commonUtil/getUtmLink] href=${href} error=${parseError(e, 'Error')}`)
    return href
  }
}
